<template>
  <div v-if="archive.length" class="events-archive">
    <h2 class="text-h2 text-color-navy">{{ $t('resources.pastEvents') }}</h2>
    <div class="events-archive__nav">
      <div
        v-for="archiveItem in archive"
        :key="archiveItem.key"
        :class="{ 'events-archive__nav-item--active': archiveItem.isActive }"
        class="events-archive__nav-item"
        @click="onNavClick(archiveItem)"
      >
        {{ archiveItem.label }}
      </div>
    </div>
    <div v-if="activeArchiveItem" class="events-archive__events-list">
      <event-item
        v-for="event in activeArchiveItem.events"
        :key="event.key"
        :eventItem="event"
        class="events-archive__event"
        @clicked="$emit('eventClicked', event)"
      />
    </div>
  </div>
  <div v-else class="events-archive">
    <h2 class="text-h2 text-color-navy">{{ $t('resources.noEventsFound') }}</h2>
  </div>
</template>
<script>
import dayjs from '@/lib/utils/dayjs'

import EventItem from '@/components/resources/particles/EventItem.vue'

export default {
  components: {
    EventItem,
  },
  props: {
    expiredEvents: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  emits: ['eventClicked'],
  data() {
    return {
      archive: [],
    }
  },
  computed: {
    activeArchiveItem() {
      return this.archive.find((item) => item.isActive)
    },
  },
  created() {
    this.initArchive()
  },
  methods: {
    initArchive() {
      const paginatedEvents = {}
      this.expiredEvents.forEach((event) => {
        const startYear = 2021
        const eventYear = dayjs(event.date).year()
        if (eventYear < startYear) return
        if (!paginatedEvents[eventYear]) {
          paginatedEvents[eventYear] = {
            key: eventYear,
            label: eventYear,
            isActive: false,
            events: [],
          }
        }
        paginatedEvents[eventYear].events.push(event)
      })

      this.archive = Object.values(paginatedEvents).sort((a, b) => b.key - a.key)
      if (this.archive.length) this.archive[0].isActive = true
    },
    onNavClick(archiveItem) {
      if (archiveItem.isActive) return
      this.activeArchiveItem.isActive = false
      archiveItem.isActive = true
    },
  },
}
</script>
